export const PLATFORM_ICONS = {
    'platform::vr': 'fa fa-vr-cardboard',
    'platform::android': 'mfa fa-android',
    'platform::ios': 'fab fa-apple',
    'platform::web': 'fas fa-globe',
    'platform::marketing': 'fas fa-bullhorn',
};

export const PLATFORM_NAMES = {
    'platform::vr': 'VR',
    'platform::android': 'Android',
    'platform::ios': 'iOS',
    'platform::web': 'Web',
    'platform::marketing': 'Marketing',
};